<template>
  <el-scrollbar>
    <label style="margin-left: 5px;font-weight: bold">员工信息:</label>
    <el-card style="margin: 5px">
      <el-form :model="employeeData" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-row>
              <el-col :span="24">
                <el-form-item label="工号：" required>
                  <el-input v-if="this.employeeNoEdit" v-model="employeeData.employee_no" placeholder="工号" />
                  <el-input v-else v-model="employeeData.employee_no" placeholder="工号" disabled/>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="姓名：" required>
                  <el-input v-model="employeeData.employee_name" placeholder="姓名" clearable/>
                </el-form-item>
                <el-form-item label="岗位：" required>
                  <el-input v-model="employeeData.job_id" placeholder="岗位" clearable/>
<!--                  <el-select v-model="employeeData.job_id" placeholder="岗位"  filterable clearable>
                    <el-option v-for="item in positionOption" :key="item.id" :label="item.field_name" :value="item.field_name"/>
                  </el-select>-->
                </el-form-item>
                <el-form-item label="职务：">
                  <el-input v-model="employeeData.position_id" placeholder="职务" clearable/>
<!--                  <el-select v-model="employeeData.position_id" placeholder="职务"  filterable clearable>
                    <el-option v-for="item in positionOption" :key="item.id" :label="item.field_name" :value="item.field_name"/>
                  </el-select>-->
                </el-form-item>
                <el-form-item label="员工类型：" required>
                  <el-select v-model="employeeData.employee_type" placeholder="员工类型" clearable>
                    <el-option v-for="item in employeeTypeList" :key="item.id" :label="item.employee_type_name"
                               :value="item.id"/>
                  </el-select>
                </el-form-item>
                <el-form-item label="手机号码：" required>
                  <el-input v-model="employeeData.phone" placeholder="手机号码" clearable/>
                </el-form-item>
                <el-form-item label="企业邮箱：">
                  <el-input v-model="employeeData.email" placeholder="企业邮箱" clearable/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <kf-image-upload class="employee-photo" v-model="employeeData.photo" :init-file="employeeData.photo_obj"
                               @fileChange="photoChange" :limit="1"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="人力资源类型：">
              <el-select v-model="employeeData.hr_type" placeholder="间接/直接"  filterable clearable>
                <el-option v-for="item in hrList" :key="item.value" :label="item.name" :value="item.value"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="厂外工龄：">
              <el-input-number style="width: 100%" v-model="employeeData.work_year_out"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="入集团日期：" required>
              <el-date-picker v-model="employeeData.entry_corporation_date" type="date" placeholder="选择日期"
                              value-format="YYYY-MM-DD" style="width: 100%"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入职日期：" required>
              <el-date-picker v-model="employeeData.entry_factory_date" type="date" placeholder="选择日期"
                              value-format="YYYY-MM-DD" style="width: 100%"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="隶属厂区：" required>
              <el-select v-model="employeeData.factory_id" placeholder="隶属厂区"  filterable disabled>
                <el-option v-for="item in factoryList" :key="item.id" :label="item.name" :value="item.id"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="隶属公司：" required>
              <el-select v-model="employeeData.company_id" placeholder="隶属公司"  filterable clearable>
                <el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.id"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="部门：" required>
              <el-cascader v-model="employeeData.all_department_ids" :options="departmentList"
                           :props="mulOptionProps" :show-all-levels="true" style="width: 100%"  @change="initLeaderDept"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="是部门负责人：">
              <div class="switch-group">
                <div
                    v-for="(deptPath, index) in employeeData.all_department_ids"
                    :key="index"
                    class="switch-item"
                >
                  <span class="dept-label">{{ `部门${index + 1}` }}：</span>
                  <el-switch v-model="employeeData.leader_dept[index]" />
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="主部门：" required>
              <el-cascader v-model="employeeData.main_department_id" :options="departmentList"
                           :props="optionProps" :show-all-levels="true" style="width: 100%"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <div style="display: flex;justify-content: space-between">
      <label style="margin-left: 5px;font-weight: bold">身份信息:</label>
      <div>
        <el-button type="primary" plain size="small" @click="getIdCardInfo">读取身份证信息</el-button>
        <label
            style="margin-left: 5px;font-size: small">请先将中国大陆身份证放置在高拍仪身份证识别区，再点击“读取身份证信息”按钮读取身份证信息</label>
      </div>
    </div>
    <el-card style="margin: 5px">
      <el-form :model="idCardInfo" class="demo-form-inline" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-row>
              <el-col :span="24">
                <el-form-item label="姓名：">
                  <el-input v-model="idCardInfo.employee_name" placeholder="姓名" clearable/>
                </el-form-item>
                <el-form-item label="性别：">
                  <el-select v-model="idCardInfo.gender" placeholder="性别" clearable>
                    <el-option label="男" value="男" />
                    <el-option label="女" value="女" />
                  </el-select>
                </el-form-item>
                <el-form-item label="民族：">
                  <el-input v-model="idCardInfo.ethnicity" placeholder="民族" clearable />
                </el-form-item>
                <el-form-item label="出生日期：">
                  <el-date-picker v-model="idCardInfo.date_of_birth" type="date"
                                  value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 100%" @change="formattedMonth"/>
                </el-form-item>
                <el-form-item label="月份：">
                  <el-input v-model="idCardInfo.birth_month" placeholder="月份" clearable disabled/>
                </el-form-item>
                <el-form-item label="公民身份证号码：" required>
                  <el-input v-model="idCardInfo.id_card_no" placeholder="公民身份证号码" clearable/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="6" :offset="5">
            <div>
              <el-image :src="idCardInfo.avatar_show" style="width: 130px;height: 160px;margin-top: 60px">
                <template #error>
                  <div class="image-slot">
                    <el-icon>
                      <icon-picture/>
                    </el-icon>
                  </div>
                </template>
              </el-image>
            </div>
          </el-col>
        </el-row>
        <el-form-item label="住址：">
          <el-input v-model="idCardInfo.address" placeholder="住址" clearable/>
        </el-form-item>
        <el-form-item label="签发机关：">
          <el-input v-model="idCardInfo.issue_authority" placeholder="签发机关" clearable/>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="有效期限从：">
              <el-date-picker v-model="idCardInfo.expire_date_start" type="date"
                              value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 100%"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="有效期限至：">
              <el-date-picker v-model="idCardInfo.expire_date_end" type="date"
                              value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 100%"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="婚姻状况：">
              <el-input v-model="idCardInfo.marital_status" placeholder="婚姻状况" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="长期有效：">
              <el-switch v-model="idCardInfo.is_permanent"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="政治面貌：">
              <el-input v-model="idCardInfo.political_affiliation" placeholder="政治面貌" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="籍贯：">
              <el-input v-model="idCardInfo.origin_domicile" placeholder="籍贯" clearable/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="照片：">
              <el-button type="primary" plain style="width: 100px" @click="openCameraMain('idCard1')">人像页拍照
              </el-button>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="">
              <el-button type="primary" plain style="width: 100px" @click="openCameraMain('idCard2')">国徽页拍照
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item>
              <kf-image-upload class="avatar-uploader" v-model="idCardInfo.man_photo_show"
                               :init-file="employeeData.man_photo_show_obj" @fileChange="photoChangeIdZ" :limit="1"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <kf-image-upload class="avatar-uploader" v-model="idCardInfo.nation_photo_show"
                               :init-file="employeeData.nation_photo_show_obj" @fileChange="photoChangeIdF" :limit="1"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">非大陆身份信息:</label>
    <el-card style="margin: 5px">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="证件类型：">
              <el-select v-model="idCardInfo.card_type_othoer" placeholder="证件类型" clearable>
                <el-option v-for="item in cardTypeList" :key="item.id" :label="item.document_name" :value="item.id"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证件号码：">
              <el-input v-model="idCardInfo.id_card_no_other" placeholder="证件号码"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="照片：">
              <el-button type="primary" plain style="width: 100px" @click="openCameraMain('card1')">正面拍照</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="">
              <el-button type="primary" plain style="width: 100px" @click="openCameraMain('card2')">反面拍照</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item>
              <kf-image-upload class="avatar-uploader" v-model="idCardInfo.man_photo_show_other"
                               :init-file="employeeData.man_photo_show_other_obj" @fileChange="photoChangeIdOtherZ"
                               :limit="1"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <kf-image-upload class="avatar-uploader" v-model="idCardInfo.nation_photo_show_other"
                               :init-file="employeeData.nation_photo_show_other_obj" @fileChange="photoChangeIdOtherF"
                               :limit="1"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">合同信息:</label>
    <el-card style="margin: 5px">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px">
        <el-row>
          <el-col :span="12">
<!--            <el-form-item label="合同公司：">
              <el-select v-model="contractData.contract_company" placeholder="合同公司" clearable>
                <el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.id"/>
              </el-select>
            </el-form-item>-->
            <el-form-item label="合同公司：">
              <el-input v-model="contractData.contract_company" placeholder="合同公司"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合同类型：">
              <el-select v-model="contractData.contract_type" placeholder="合同类型" clearable>
                <el-option v-for="item in contractTypeList" :key="item.id" :label="item.contracts_type" :value="item.id"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="首次合同起始日：">
              <el-date-picker v-model="contractData.first_contract_start_date" type="date"
                              value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 100%"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="首次合同到期日：">
              <el-date-picker v-model="contractData.first_contract_end_date" type="date"
                              value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 100%"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="现合同起始日：">
              <el-date-picker v-model="contractData.now_contract_start_date" type="date"
                              value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 100%"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="现合同到期日：">
              <el-date-picker v-model="contractData.now_contract_end_date" type="date"
                              value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 100%"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="合同期限：">
              <el-input v-model="contractData.contract_period_type" placeholder="合同期限"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="剩余天数：">
              <el-input v-model="contractData.contract_remaining_days" placeholder="剩余天数"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="到期提醒：">
              <el-input v-model="contractData.contract_expire_tip" placeholder="到期提醒"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="续签次数：">
              <el-input v-model="contractData.contract_renew_count" placeholder="续签次数"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="合同备注：">
              <el-input v-model="contractData.remark" placeholder="合同备注" :rows="2" type="textarea"
                        clearable/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">试用期选项:</label>
    <el-card style="margin: 5px">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否试用期：">
              <el-switch v-model="employeeData.is_probation" @change="getProbationEndDate"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="试用期：">
              <el-select v-model="employeeData.probation_period_type" placeholder="试用期" clearable>
                <el-option v-for="item in probationList" :key="item.value" :label="item.name" :value="item.value"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="计划转正日期：">
              <el-date-picker type="date" value-format="YYYY-MM-DD" v-model="employeeData.probation_end_date"
                              placeholder="选择日期" style="width: 100%" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="试用状态：">
              <el-select v-model="employeeData.user_status" placeholder="试用状态" clearable>
                <el-option label="试用" value="probation" />
                <el-option label="试岗" value="trail" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">考勤选项:</label>
    <el-card style="margin: 5px">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="参与考勤：">
              <el-switch v-model="employeeData.is_join_attendance"/>
            </el-form-item>
          </el-col>
          <!--          <el-col :span="12">
                      <el-form-item label="考勤组：">
                        <el-select v-model="employeeData.group_id" placeholder="考勤组" clearable>
                          <el-option v-for="item in attendanceGroupList" :key="item.id" :label="item.group_name" :value="item.id"/>
                        </el-select>
                      </el-form-item>
                    </el-col>-->
        </el-row>
      </el-form>
    </el-card>
<!--    <label style="margin-left: 5px;font-weight: bold">薪资选项:</label>
    <el-card style="margin: 5px">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="薪资类型：">
              <el-select v-model="salaryTypeItem" value-key="id" @change="salaryChange" placeholder="薪资类型"
                         clearable>
                <el-option v-for="item in salaryTypeList" :key="item.id" :label="item.salary_type" :value="item"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="薪资(底薪)：">
              <el-input-number :min="0" v-model="employeeData.salary" step="1000" :precision="2"
                               placeholder="薪资(底薪)" style="width: 100%" clearable/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="标准津贴：">
              <el-input-number :min="0" v-model="employeeData.salary_allowance" :precision="2" step="1000"
                               placeholder="标准津贴" style="width: 100%" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="标准补贴：">
              <el-input-number :min="0" v-model="employeeData.salary_subsidy" :precision="2" step="1000"
                               placeholder="标准补贴" style="width: 100%" clearable/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="综合工资：">
              <el-input-number :min="0" v-model="employeeData.salary_contract" step="1000" :precision="2" placeholder="综合工资" style="width: 100%" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="防尘服补贴：">
              <el-switch v-model="employeeData.is_cloth_subsidy"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="补贴选项：">
              <el-switch v-model="employeeData.is_customization_subsidy" active-text="自定义补贴"/>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item label="">
              <el-checkbox v-model="employeeData.salary_car" :disabled="!employeeData.is_customization_subsidy"
                           style="margin-right: 8px">车补
              </el-checkbox>
              <el-checkbox v-model="employeeData.salary_house" :disabled="!employeeData.is_customization_subsidy"
                           style="margin-right: 8px">房补
              </el-checkbox>
              <el-checkbox v-model="employeeData.salary_on_job" :disabled="!employeeData.is_customization_subsidy"
                           style="margin-right: 8px">在职奖
              </el-checkbox>
              <el-checkbox v-model="employeeData.salary_full_attendance"
                           :disabled="!employeeData.is_customization_subsidy" style="margin-right: 8px">全勤奖
              </el-checkbox>
              <el-checkbox v-model="employeeData.salary_work_year" :disabled="!employeeData.is_customization_subsidy"
                           style="margin-right: 8px">工龄奖
              </el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>-->
    <label style="margin-left: 5px;font-weight: bold">工资卡信息:</label>
    <el-card style="margin: 5px;">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="工资卡卡号：">
              <el-input v-model="employeeData.bank_card_no" placeholder="工资卡卡号" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="照片：">
              <el-button type="primary" plain style="width: 100px" @click="openCameraMain('bank')">拍照</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-row>
              <el-col :span="24">
                <el-form-item label="银行：" required>
                  <el-select v-model="employeeData.bank_id" placeholder="银行" clearable>
                    <el-option v-for="item in bankList" :key="item.id" :label="item.name" :value="item.id"/>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="开户行：">
                  <el-input v-model="employeeData.account_bank" placeholder="开户行" :rows="4" type="textarea"
                            clearable/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <kf-image-upload class="avatar-uploader" v-model="employeeData.bank_card_photo"
                               :init-file="employeeData.bank_card_photo_obj" @fileChange="photoChangeBank" :limit="1"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">社保:</label>
    <el-card style="margin: 5px;">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-row>
              <el-col :span="24">
                <el-form-item label="社保配置：">
                  <el-select v-model="socialSecurityTmplData" value-key="id" placeholder="社保配置" @change="getSbBase"
                             clearable>
                    <el-option v-for="item in socialSecurityTmplList" :key="item.id" :label="item.name" :value="item"/>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="社保缴纳地：">
                  <el-input v-model="employeeData.sb_base_area" placeholder="社保缴纳地" disabled clearable/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="社保账号：">
                  <el-input v-model="employeeData.sb_card_no" placeholder="社保账号" clearable/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="缴费基数：">
                  <el-col :span="6">
                    <el-checkbox v-model="employeeData.is_custom_base" @change="setSbBase" name="self" size="small">
                      自定义
                    </el-checkbox>
                  </el-col>
                  <el-col :span="18">
                    <el-input v-model="employeeData.sb_base" placeholder="缴费基数" :disabled="is_custom" clearable/>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="个人部分承担方：">
                  <el-select v-model="employeeData.sb_pay_type" placeholder="个人部分承担方" clearable>
                    <el-option v-for="item in costBoolList" :key="item.value" :label="item.name" :value="item.value"/>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-col :span="24">
                <el-form-item label="照片：">
                  <el-button type="primary" plain @click="openCameraMain('social')">社保卡拍照</el-button>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item>
                  <kf-image-upload class="avatar-uploader" v-model="employeeData.sb_card_photo"
                                   :init-file="employeeData.sb_card_photo_obj" @fileChange="photoChangeSb" :limit="1"/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">公积金:</label>
    <el-card style="margin: 5px;">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-row>
              <el-col :span="24">
                <el-form-item label="公积金配置：">
                  <el-select v-model="housingFundTmplData" value-key="id" placeholder="公积金配置"
                             @change="getHousingBase" clearable>
                    <el-option v-for="item in housingFundTmplList" :key="item.id" :label="item.name" :value="item"/>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="公积金缴纳地：">
                  <el-input v-model="employeeData.gjj_base_area" placeholder="公积金缴纳地" disabled clearable/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="公积金账号：">
                  <el-input v-model="employeeData.housing_fund_no" placeholder="公积金账号" clearable/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="缴费基数：">
                  <el-col :span="6">
                    <el-checkbox v-model="employeeData.is_custom_base_gjj" @change="setHousingBase" name="self"
                                 size="small">自定义
                    </el-checkbox>
                  </el-col>
                  <el-col :span="18">
                    <el-input v-model="employeeData.gjj_base" placeholder="缴费基数" :disabled="is_custom_gjj"
                              clearable/>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="额外部分承担方：">
                  <el-select v-model="employeeData.gjj_pay_type" placeholder="额外部分承担方" clearable>
                    <el-option v-for="item in costBoolList" :key="item.value" :label="item.name" :value="item.value"/>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-col :span="24">
                <el-form-item label="照片：">
                  <el-button type="primary" plain @click="openCameraMain('house')">公积金卡拍照</el-button>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item>
                  <kf-image-upload class="avatar-uploader" v-model="employeeData.housing_fund_photo"
                                   :init-file="employeeData.housing_fund_photo_obj" @fileChange="photoChangeHouse"
                                   :limit="1"/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">学历信息:</label>
    <el-card style="margin: 5px" id="educationCard">
      <el-form :model="educationData" class="demo-form-inline" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="学历：">
              <el-select v-model="educationData.education" placeholder="学历" clearable>
                <el-option v-for="item in educationLevelList" :key="item.id" :label="item.education_level_name" :value="item.id"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学校：">
              <el-input v-model="educationData.school" placeholder="学校" clearable/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="学院：">
              <el-input v-model="educationData.college" placeholder="学院" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="专业：">
              <el-input v-model="educationData.major" placeholder="专业" clearable/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="入学时间：" >
              <el-date-picker v-model="educationData.entry_date" type="date"
                              value-format="YYYY-MM-DD" placeholder="请选择" style="width: 100%"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="毕业时间：" >
              <el-date-picker v-model="educationData.graduation_date" type="date"
                              value-format="YYYY-MM-DD" placeholder="请选择" style="width: 100%"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="照片：">
              <el-button type="primary" style="width: 100px;" plain @click="openCameraMain('school1')">毕业证书拍照
              </el-button>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="">
              <el-button type="primary" style="width: 100px;" plain @click="openCameraMain('school2')">学位证书拍照
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item>
              <kf-image-upload class="avatar-uploader" v-model="educationData.by_certificate"
                               :init-file="employeeData.by_certificate_obj" @fileChange="photoChangeBY" :limit="1"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <kf-image-upload class="avatar-uploader" v-model="educationData.xw_certificate"
                               :init-file="employeeData.xw_certificate_obj" @fileChange="photoChangeXW" :limit="1"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card style="margin: 5px" v-show="employeeData.educationData && employeeData.educationData.length > 0">
      <el-timeline>
        <el-timeline-item v-for="(item,index) in employeeData.educationData" :key="index" :timestamp="item.title"
                          placement="top">
          <el-card>
            <h4>{{ item.school }}</h4>
            <el-row>
              <el-col :span="18">
                <p>{{ item.education_name }}|{{ item.major }}</p>
              </el-col>
              <el-col :span="2" :offset="4">
                <el-button type="primary" plain size="small" @click="delEduHistory(index)">删除</el-button>
              </el-col>
            </el-row>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">联络信息:</label>
    <el-card style="margin: 5px;">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="紧急联系人姓名：">
              <el-input v-model="employeeData.emergency_name" placeholder="紧急联系人姓名" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="关系：">
              <el-select v-model="employeeData.emergency_relation" placeholder="关系" clearable>
                <el-option v-for="item in emergencyRelationList" :key="item.id" :label="item.relationship" :value="item.id"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :span="12" label="紧急联系人电话：">
              <el-input v-model="employeeData.emergency_contact" placeholder="紧急联系人电话" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否住宿：">
              <el-switch v-model="employeeData.is_dormitory"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="住址：">
              <el-input v-model="employeeData.address_actual" placeholder="住址" clearable/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">备注信息:</label>
    <el-card style="margin: 5px;">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否有体检表：">
              <el-switch v-model="employeeData.is_pe"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="奖惩备注：">
              <el-input v-model="employeeData.reward_warning_remark" placeholder="奖惩备注" :rows="2" type="textarea"
                        clearable/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="工伤备注：">
              <el-input v-model="employeeData.work_injury_remark" placeholder="工伤备注" :rows="2" type="textarea"
                        clearable/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="三期女工备注：">
              <el-input v-model="employeeData.female_remark" placeholder="三期女工备注" :rows="2" type="textarea"
                        clearable/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="其它备注：">
              <el-input v-model="employeeData.remark" placeholder="其它备注" :rows="2" type="textarea"
                        clearable/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">招聘来源:</label>
    <el-card style="margin: 5px;">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="推荐人工号：">
              <el-input v-model="employeeData.job_referral_no" placeholder="推荐人" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="推荐人姓名：">
              <el-input v-model="employeeData.job_referral_name" placeholder="推荐人" clearable/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="招聘来源：">
              <el-input v-model="employeeData.recruit_source" placeholder="招聘来源" clearable/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">其它附件:</label>
    <el-card style="margin: 5px;">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="附件：">
              <FrameItem v-model="employeeData.attach_id" :file-list="employeeData.fileList" :item="uploadObj"></FrameItem>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="">
              <el-button type="primary" style="width: 100px;" plain @click="openCameraMain('attach')">附件拍照
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="">
              <FrameItem v-model="employeeData.attach_photo_id" :file-list="employeeData.attach_photo_id_obj"
                         :item="uploadImgObj"></FrameItem>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <div style="text-align: center">
      <el-button type="primary" :loading="loading" @click="saveEmployeeInfo">保存</el-button>
    </div>
  </el-scrollbar>
  <el-dialog v-model="dialogVisible" style="width: 800px;height: 550px;">
    <div class="video-thumbnail">
      <img id="view2" src="http://127.0.0.1:38088/video=stream&camidx=1" alt="副摄像头"
           style="width: 770px;height:450px;">
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="closeCamera">取消</el-button>
        <el-button type="primary" @click="takePhoto">
          拍照
        </el-button>
      </div>
    </template>
  </el-dialog>
  <el-dialog v-model="dialogVisibleTwo" style="width: 800px;height: 550px;">
    <img id="view1" src="http://127.0.0.1:38088/video=stream&camidx=0" alt="主摄像头"
         style="width: 770px;height:450px;">
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="closeCameraMain">取消</el-button>
        <el-button type="primary" @click="takePhotoTwo">
          拍照
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>

import {Picture as IconPicture, Plus, Upload} from "@element-plus/icons-vue";
import {ref} from 'vue';
import axios from 'axios';
import moment from "moment";

export default {
  name: "EmployeeInfoEdit",
  components: {Upload, Plus, IconPicture, ref},
  inject: ['$fn'],
  setup() {
    const cameraUrl = ref('http://127.0.0.1:38088/video=stream&camidx=1');
    return {
      cameraUrl,
    };
  },
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  computed: {
    boolList() {
      return this.$store.getters['core/getDictList']('bool');
    },
    hrList(){
      return this.$store.getters['core/getDictList']('hr_type');
    },
    marriageList(){
      return this.$store.getters['core/getDictList']('marriage_status');
    },
    probationList(){
      return this.$store.getters['core/getDictList']('probation_type');
    }
    // costBoolList() {
    //   return this.$store.getters['core/getDictList']('salary_social_cost');
    // }
  },
  data() {
    return {
      optionProps: {
        emitPath: false,
        value: 'id',
        label: 'name',
        checkStrictly: true
      },
      mulOptionProps: {
        emitPath: false,
        label: "name",
        value: "id",
        checkStrictly: true,
        multiple: true
      },
      costBoolList: [
        {value: true, name: '个人承担'},
        {value: false, name: '公司承担'}
      ],
      employeeData: {
        employee_no: '',
        employee_name: '',
        department_ids: [],
        is_leader:false,
        leader_dept:[],
        position_id: '',
        salary: '',
        gender: '',
        birthday: '',
        age: '',
        id_card_no: '',
        phone: '',
        email: '',
        address: '',
        emergency_contact: '',
        bank_card_no: '',
        is_probation: false,
        is_customization_subsidy: false,
        is_join_attendance: false,
        probation_end_date: '',
        idCardInfo: {},
        contractData: {},
        salaryData: {},
        educationData: {}
      },
      dialogVisible: false,
      dialogVisibleTwo: false,
      photoType: '',
      is_custom: true,
      is_custom_gjj: true,
      idCardInfo: {},
      contractData: {},
      salaryData: {},
      educationData: {},
      eduLevelData: {},
      workExperienceData: {},
      departmentList: [],
      positionList: [],
      // jobLevelList: [],
      ddTypeOption: [],
      employeeTypeList: [],
      contractTypeList: [],
      salaryTypeItem: {},
      salaryTypeList: [],
      bankList: [],
      socialSecurityCostList: [],
      socialSecurityBaseTypeList: [],
      socialSecurityAreaList: [],
      emergencyRelationList: [],
      educationLevelList: [],
      socialSecurityTmplData: {},
      housingFundTmplData: {},
      socialSecurityTmplList: [],
      housingFundTmplList: [],
      cardTypeList: [],
      laborCompanyList: [],
      attendanceGroupList: [],
      positionOption: [],
      factoryList: [],
      companyList: [],
      loading: false,
      imageUrl: '',
      uploadObj: {
        component: 'file_upload',
        limit: 1,
      },
      uploadImgObj: {
        component: 'image_upload',
        limit: 1,
      },
      employeeNoEdit:false,
      sexOption:[],
      nationOption:[],
      marriageOption:[],
      residenceOption:[],
      politicaleOption:[],
      contractCompanyOption:[],
      contractTypeOption:[],
      contractPeriodTypeOption:[],
      emergencyOption:[],
      laborOption:[],
      reportManagerOption:[],
      probationOption:[]
    }
  },
  methods: {
    async loadEmpInfo() {
      let params = {id: this.parentData.id};
      let dbEmployee = await this.$http('employeeInfoService.getEmployeeInfo', params);
      console.log("dbEmployee.bank_card_photo", dbEmployee.bank_card_photo)

      if (dbEmployee) {
        this.employeeData = dbEmployee;
        if(this.employeeData.employee_no ==='' || !this.employeeData.employee_no){
          this.employeeNoEdit=true;
        }
        this.is_custom = !this.employeeData.is_custom_base;
        this.is_custom_gjj = !this.employeeData.is_custom_base_gjj;

        const deptIds = this.employeeData.all_department_ids || [];
        let leaderFlags = [];
        if (this.employeeData.is_department_leader && Array.isArray(this.employeeData.is_department_leader)) {
          // 按索引一一对应，长度以 deptIds 为准（更安全）
          leaderFlags = deptIds.map((_, index) => {
            const val = this.employeeData.is_department_leader[index];
            return val === "1" || val === true;
          });
        } else {
          // 没有负责人数据，默认全 false
          leaderFlags = new Array(deptIds.length).fill(false);
        }
        this.employeeData.leader_dept = leaderFlags;
        if (dbEmployee.idCardInfo) {
          this.idCardInfo = dbEmployee.idCardInfo;
        }
        if (dbEmployee.contractData) {
          this.contractData = dbEmployee.contractData
          this.contractData.contract_type =dbEmployee.contractData.contract_type;
        }
        if (dbEmployee.educationData) {
          this.educationData = dbEmployee.educationData;
          this.eduLevelData = dbEmployee.educationData.eduLevelData;
          /*this.educationData.education_name = this.eduLevelData.education_level_name;
          this.educationData.education = this.eduLevelData.id;*/
          console.log(this.educationData.education);
        }
        this.employeeData.emergency_relation = dbEmployee.emergency_relation;
        console.log(this.employeeData.emergency_relation);
        if (this.salaryTypeList && dbEmployee.salary_type_id !== undefined) {
          const foundItem = this.salaryTypeList.find((item) => item.id === dbEmployee.salary_type_id);
          if (foundItem) {
            this.salaryTypeItem = foundItem;
          }
        }
        if (dbEmployee.sb_template_id) {
          for (let sbTmplList of this.socialSecurityTmplList) {
            if (sbTmplList.id === dbEmployee.sb_template_id) {
              this.getSbBase(sbTmplList)
              break
            }
          }
        }
        if (dbEmployee.gjj_template_id) {
          for (let gjjAreaList of this.housingFundTmplList) {
            if (gjjAreaList.id === dbEmployee.gjj_template_id) {
              this.getHousingBase(gjjAreaList)
              break
            }
          }
        }
      }
    },
    //获取部门列表
    async getDepartmentList() {
      this.departmentList = await this.$http('sysUserDepartmentService.getDepartmentData');
      console.log(this.departmentList);
    },
    //获取员工类型
    async getEmployeeType() {
      let params = {modelId: "hr_employee_type"}
      this.employeeTypeList = await this.$http('employeeHRService.getAll', params);
    },
    //获取员工类型
    async getDDTypeOption() {
      let params = {group_id: "sys01-employeeType"}
      this.ddTypeOption = await this.$http('employeeInfoService.getRosterOptionList',params);
    },
    //获取职位
    async getPositionOption() {
      let params = {group_id: "职位"}
      this.positionOption = await this.$http('employeeInfoService.getRosterOptionList',params);
    },
    //获取性别
    async getSexOption() {
      let params = {group_id: "sys02-sexType"}
      this.sexOption = await this.$http('employeeInfoService.getRosterOptionList',params);
    },
    //获取民族
    async getNationOption() {
      let params = {group_id: "sys02-nationType"}
      this.nationOption = await this.$http('employeeInfoService.getRosterOptionList',params);
    },
    //获取婚姻
    async getMarriageOption() {
      let params = {group_id: "sys02-marriage"}
      this.marriageOption = await this.$http('employeeInfoService.getRosterOptionList',params);
    },
    //获取户籍
    async getResidenceOption() {
      let params = {group_id: "sys02-residenceType"}
      this.residenceOption = await this.$http('employeeInfoService.getRosterOptionList',params);
    },
    //获取政治面貌
    async getPoliticalOption() {
      let params = {group_id: "sys02-politicalStatus"}
      this.politicaleOption = await this.$http('employeeInfoService.getRosterOptionList',params);
    },
    //获取合同公司
    async getContractCompanyOption() {
      let params = {group_id: "sys05-contractCompanyName"}
      this.contractCompanyOption = await this.$http('employeeInfoService.getRosterOptionList',params);
    },
    //获取合同期限
    async getContractPeriodTypeOption() {
      let params = {group_id: "sys05-contractPeriodType"}
      this.contractPeriodTypeOption = await this.$http('employeeInfoService.getRosterOptionList',params);
    },
    //获取紧急联系人关系
    async getEmergencyOption() {
      let params = {group_id: "sys06-urgentContactsRelation"}
      this.emergencyOption = await this.$http('employeeInfoService.getRosterOptionList',params);
    },
    //获取劳务公司
    async getLaborOption() {
      let params = {group_id: "2fba67c0-c6b2-43d6-89f5-ea531257483a"}
      this.laborOption = await this.$http('employeeInfoService.getRosterOptionList',params);
    },
    //获取直属主管
    async getReportManagerOption() {
      let params = {}
      this.reportManagerOption = await this.$http("employeeInfoService.getAllEmployeeListByDept",params);
    },
    //获取试用期
    async getProbationTypeOption() {
      let params = {group_id: "sys01-probationPeriodType"}
      this.probationOption = await this.$http('employeeInfoService.getRosterOptionList',params);
    },
    getProbationEndDate() {
      if (this.employeeData.is_probation) {
        let endDate = moment().add(6, 'month').toDate();
        this.employeeData.probation_end_date = moment(endDate).format('YYYY-MM-DD');
      } else {
        this.employeeData.probation_end_date = '';
      }
    },
    //获取合同类型
    async getContractType() {
      let params = {modelId: "hr_contracts_type"}
      this.contractTypeList = await this.$http('employeeHRService.getAll', params);
    },
    //获取学历列表
    async getEducation() {
      let params = {modelId: "hr_education_level"}
      this.educationLevelList = await this.$http('employeeHRService.getAll', params);
    },
    //获取薪资类型
    async getSalaryType() {
      let params = {modelId: "salary_type"}
      this.salaryTypeList = await this.$http('salaryTypeSetService.getAll', params);
    },
    //获取开户行
    async getSalaryBank() {
      let params = {modelId: "salary_bank"}
      this.bankList = await this.$http('employeeHRService.getAll', params);
    },
    //获取个人部分社保承担放
    async getSocialSecurity() {
      let params = {modelId: "salary_social_security_cost"}
      this.socialSecurityCostList = await this.$http('employeeHRService.getAll', params);
    },
    //获取社保基数类型
    async getSocialSecurityBase() {
      let params = {modelId: "salary_base_type"}
      this.socialSecurityBaseTypeList = await this.$http('employeeHRService.getAll', params);
    },
    //获取社保缴纳地
    async getSocialSecurityArea() {
      let params = {modelId: "salary_social_security_area"}
      this.socialSecurityAreaList = await this.$http('employeeHRService.getAll', params);
    },
    //获取紧急联系人关系
    async getEmergencyRelation() {
      let params = {modelId: "hr_emergency_contacts"}
      this.emergencyRelationList = await this.$http('employeeHRService.getAll', params);
    },
    //获取劳务公司列表
    async getLaborCompany() {
      let params = {modelId: "hr_labor_company"}
      this.laborCompanyList = await this.$http('employeeHRService.getAll', params);
    },
    //获取考勤组列表
    async getAttendanceGroup() {
      let params = {modelId: "attendance_group"}
      this.attendanceGroupList = await this.$http('attendanceGroupService.getAll', params);
    },
    //获取社保模板列表
    async getSocialSecurityTmpl() {
      let params = {modelId: "salary_social_security_template"}
      this.socialSecurityTmplList = await this.$http('salaryInfoSetService.getAllSecurityTmpl', params);
      // console.log("this.socialSecurityTmplList",this.socialSecurityTmplList)
    },
    //获取公积金模板列表
    async getHousingFundTmpl() {
      let params = {modelId: "salary_provident_fund_template"}
      this.housingFundTmplList = await this.$http('salaryInfoSetService.getAllHousingTmpl', params);
    },
    //获取证件类型
    async getCardType() {
      let params = {modelId: "hr_document"}
      this.cardTypeList = await this.$http('employeeHRService.getAll', params);
    },
    //获取厂区
    async getFactory() {
      let params = {modelId: "hr_document"}
      this.factoryList = await this.$http('sysFactoryService.getAllFactory', params);
    },
    //获取公司
    async getCompany() {
      let params = {modelId: "hr_document"}
      this.companyList = await this.$http('sysFactoryService.getCompanyByUser', params);
    },
    getEduName(item) {
      if(item){
        this.eduLevelData = item;
        this.educationData.education_name = item.education_level_name;
        this.educationData.education = item.id;
      }else {
        this.educationData.education_name = '';
        this.educationData.education = '';
      }
    },
    getSbBase(item) {
      if(item){
        this.socialSecurityTmplData = item;
        this.employeeData.sb_template_id = item.id;
        this.employeeData.sb_base_area = item.area_name;
        if(!this.employeeData.is_custom_base){
          this.employeeData.sb_base = item.base_pay;
        }
      }else {
        this.employeeData.sb_template_id = '';
        this.employeeData.sb_base_area = '';
      }
    },
    setSbBase() {
      if (this.employeeData.is_custom_base) {
        this.is_custom = false;
      } else {
        this.is_custom = true;
      }
    },

    getHousingBase(item) {
      if(item){
        this.housingFundTmplData = item;
        this.employeeData.gjj_template_id = item.id;
        this.employeeData.gjj_base_area = item.area_name;
        if(!this.employeeData.is_custom_base_gjj){
          this.employeeData.gjj_base = item.base_pay;
        }
      }else {
        this.employeeData.gjj_template_id = '';
        this.employeeData.gjj_base_area = '';
      }
    },
    setHousingBase() {
      // console.log(this.employeeData.is_custom_base_gjj);
      if (this.employeeData.is_custom_base_gjj) {
        this.is_custom_gjj = false;
      } else {
        this.is_custom_gjj = true;
      }
    },
    initLeaderDept(newVal){
      this.employeeData.leader_dept = new Array(newVal.length).fill(false);
    },
    salaryChange(item) {
      // console.log(item);
      this.salaryTypeItem = item;
      this.employeeData.salary_type_id = item.id;
      this.employeeData.salary_car = item.salary_car;
      this.employeeData.salary_house = item.salary_house;
      this.employeeData.salary_on_job = item.salary_on_job;
      this.employeeData.salary_full_attendance = item.salary_full_attendance;
      this.employeeData.salary_work_year = item.salary_work_year;
    },
    addEducationHistory() {
      //document.getElementById('educationCard').style.display = 'block';
      if (!this.educationData.education) {
        return this.$message.error("学历不能为空")
      }
      if (!this.educationData.school) {
        return this.$message.error("学校不能为空")
      }
      if (!this.educationData.major) {
        return this.$message.error("专业不能为空")
      }
      if (!this.educationData.entry_date) {
        return this.$message.error("学历开始时间不能为空")
      }
      if (!this.educationData.graduation_date) {
        return this.$message.error("学历结束时间不能为空")
      }
      //this.educationData.entry_date  = this.educationData.entry_date.toLocaleDateString();
      //this.educationData.graduation_date  = this.educationData.graduation_date.toLocaleDateString();
      this.educationData.title = this.educationData.entry_date + " ~ " + this.educationData.graduation_date;
      if(!this.employeeData.educationData){
        this.employeeData.educationData = [];
      }
      this.employeeData.educationData.push(this.educationData);
      this.employeeData.educationData.sort((a, b) => {
        return a.entry_date - b.entry_date;
      });
      this.educationData = {};
      this.eduLevelData = {};
    },
    //删除列表中的学历
    delEduHistory(index) {
      // console.log(index);
      this.employeeData.educationData.splice(index, 1);
    },
    cancelWork() {
      document.getElementById('educationCard').style.display = 'none';
    },
    formattedMonth() {
      if(this.idCardInfo.date_of_birth){
        const date = new Date(this.idCardInfo.date_of_birth)
        this.idCardInfo.birth_month =  `${date.getMonth() + 1}月`
      }else {
        this.idCardInfo.birth_month = ''
      }
    },
    //获取二代身份证信息
    getIdCardInfo() {
      axios.get("http://127.0.0.1:38088/card=idcard").then(response => {
        if (response) {
          let params = {userInfo: response.data};
          this.$http('photoService.getIdCardInfo', params, false).then(data => {
            this.idCardInfo = data;
            if (this.idCardInfo) {
              this.idCardInfo.avatar_show = data.avatar_url;
              this.idCardInfo.avatar = data.avatar;
              this.idCardInfo.man_photo_show = data.man_photo;
              this.employeeData.man_photo_show_obj = [data.man_photo_obj];
              this.idCardInfo.nation_photo_show = data.nation_photo;
              this.employeeData.nation_photo_show_obj = [data.nation_photo_obj];
            }
          }, errMsg => {
            this.$message.error(errMsg)
            console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
          });
        }
      })
    },
    //获取ic卡
    getICCardInfo(type) {
      document.getElementById('view1').src = 'http://127.0.0.1:38088/video=stream&camidx=0';
      let params = {cardType: type}
      this.$http('photoService.orcPhoto', params, false).then(data => {
        this.idCardInfo = data;
      }, errMsg => {
        this.$message.error(errMsg)
        console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
      });
    },
    //拍照
    async openCamera() {
      this.dialogVisible = true;
      //设置分辨率
      let data = {
        "mode": "0",
        "camidx": "1",
        "width": "1280",
        "height": "720"
      }
      try {
        const image = document.getElementById('view2');
        axios.post("http://127.0.0.1:38088/device=setresolution", JSON.stringify(data)).then(response => {
          console.log(response.data);
          if (response.data.code === "0") {
            image.src = '';
          }
          image.src = 'http://127.0.0.1:38088/video=stream&camidx=1?1';
        });
      } catch (error) {
        this.$message.error("摄像头打开失败" + error.message);
      }
      //await this.$http('photoService.setCamera');
    },
    takePhoto() {
      let params = {
        "filepath": "base64",
        "camidx": "1",
        "ColorMode": "0",
        "quality": "1"
      }
      axios.post("http://127.0.0.1:38088/video=grabimage", JSON.stringify(params)).then(response => {
        if (response) {
          let data = {photo: response.data};
          this.$http('photoService.takePhoto', data, false).then(data => {
            if (data) {
              this.employeeData.photo = data.avatar;
              this.employeeData.photo_obj = [data.file];
              this.dialogVisible = false;
              console.log(this.employeeData.photo_obj);
            }
          }, errMsg => {
            this.$message.error(errMsg)
            console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
          });
        }
      });
    },
    closeCamera() {
      let data = {"camidx": "1"}
      axios.post("http://127.0.0.1:38088/video=close", JSON.stringify(data)).then(() => {
        document.getElementById('view2').src = ''
      });
      this.dialogVisible = false;
    },
    //拍银行卡等
    async openCameraMain(photoType) {
      this.dialogVisibleTwo = true;
      this.photoType = photoType;
      //await this.$http('photoService.setCamera');
      const image = document.getElementById('view1');
      image.src = 'http://127.0.0.1:38088/video=stream&camidx=0?1';
    },
    closeCameraMain() {
      let data = {"camidx": "0"}
      axios.post("http://127.0.0.1:38088/video=close", JSON.stringify(data)).then(() => {
        document.getElementById('view1').src = ''
      });
      this.dialogVisibleTwo = false;
    },
    takePhotoTwo() {
      let params = {
        "filepath": "base64",
        "camidx": "0",
        "ColorMode": "0",
        "quality": "1"
      }
      axios.post("http://127.0.0.1:38088/video=grabimage", JSON.stringify(params)).then(response => {
        if (response) {
          let photoData = {photo: response.data};
          this.$http('photoService.takePhotoByMainCamera', photoData, false).then(data => {
            if (data) {
              switch (this.photoType) {
                case "card1":
                  this.idCardInfo.man_photo_show_other = data.avatar;
                  this.employeeData.man_photo_show_other_obj = [data.file];
                  break;
                case "card2":
                  this.idCardInfo.nation_photo_show_other = data.avatar;
                  this.employeeData.nation_photo_show_other_obj = [data.file];
                  break;
                case "idCard1":
                  this.idCardInfo.man_photo_show = data.avatar;
                  this.employeeData.man_photo_show_obj = [data.file];
                  break;
                case "idCard2":
                  this.idCardInfo.nation_photo_show = data.avatar;
                  this.employeeData.nation_photo_show_obj = [data.file];
                  break;
                case "bank":
                  this.employeeData.bank_card_photo = data.avatar;
                  this.employeeData.bank_card_photo_obj = [data.file];
                  break;
                case "social":
                  this.employeeData.sb_card_photo = data.avatar;
                  this.employeeData.sb_card_photo_obj = [data.file];
                  break;
                case "house":
                  this.employeeData.housing_fund_photo = data.avatar;
                  this.employeeData.housing_fund_photo_obj = [data.file];
                  break;
                case "school1":
                  this.educationData.by_certificate = data.avatar;
                  this.employeeData.by_certificate_obj = [data.file];
                  break;
                case "school2":
                  this.educationData.xw_certificate = data.avatar;
                  this.employeeData.xw_certificate_obj = [data.file];
                  break;
                case "attach":
                  this.employeeData.attach_photo_id = data.avatar;
                  this.employeeData.attach_photo_id_obj = [data.file];
                  break;
              }
              this.dialogVisibleTwo = false;
            }
          }, errMsg => {
            this.$message.error(errMsg)
            console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
          });
        }
      });
    },
    saveEmployeeInfo() {
      if (!this.employeeData.employee_no) {
        return this.$message.error("员工工号不能为空")
      }
      /*if (this.employeeData.employee_no.length !== 6) {
        return this.$message.error("员工工号必须为6位数")
      }*/
      if (!this.employeeData.employee_name) {
        return this.$message.error("员工姓名不能为空")
      }
      if (!this.employeeData.job_id) {
        return this.$message.error("员工岗位不能为空")
      }
      if(!this.employeeData.phone){
        return this.$message.error("员工手机号不能为空")
      }
      if(!this.employeeData.main_department_id || this.employeeData.main_department_id.length === 0){
        return this.$message.error("员工部门不能为空")
      }
      if (this.idCardInfo && this.idCardInfo.id_card_no_other && this.idCardInfo.id_card_no) {
        return this.$message.error("只需输入一个证件号")
      }
      if (this.idCardInfo.id_card_no) {
        this.idCardInfo.card_type = "idCard";
      }
      if (this.idCardInfo && this.idCardInfo.id_card_no) {
        if (!this.idCardInfo.employee_name) {
          return this.$message.error("身份证姓名不能为空")
        }
        if (this.idCardInfo.employee_name !== this.employeeData.employee_name) {
          return this.$message.error("身份证姓名与员工姓名不相同")
        }
        if (this.idCardInfo.expire_date_start && this.idCardInfo.expire_date_end && this.idCardInfo.expire_date_start > this.idCardInfo.expire_date_end) {
          return this.$message.error("身份证有效期结束日期不能小于开始日期");
        }
      }
      if (this.contractData && this.contractData.length > 0) {
        if (this.contractData.contract_effect_date && this.contractData.contract_expire_date && this.contractData.contract_effect_date > this.contractData.contract_expire_date) {
          return this.$message.error("合同结束日不能小于起始日");
        }
      }
      this.employeeData.idCardInfo = this.idCardInfo;
      this.employeeData.contractData = this.contractData;
      this.employeeData.educationData = this.educationData
      this.loading = true;
      this.$http('employeeInfoService.edit', this.employeeData, false).then(() => {
        this.$message.success("保存成功");
        this.$fn.closeWindow();
        this.$fn.search();
        this.loading = false;
      }, errMsg => {
        this.$message.error(errMsg)
        console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
        this.loading = false;
      })
    },
    async photoChange(ids) {
      console.log(ids)
      if (ids.length <= 0) {
        this.employeeData.photo = ''
        return
      }
      this.employeeData.photo = ids[0];
    },
    async photoChangeIdZ(ids) {
      console.log(ids)
      if (ids.length <= 0) {
        this.idCardInfo.man_photo_show = ''
        return
      }
      this.idCardInfo.man_photo_show = ids[0];
    },
    async photoChangeIdF(ids) {
      console.log(ids)
      if (ids.length <= 0) {
        this.idCardInfo.nation_photo_show = ''
        return
      }
      this.idCardInfo.nation_photo_show = ids[0];
    },
    async photoChangeIdOtherZ(ids) {
      console.log(ids)
      if (ids.length <= 0) {
        this.idCardInfo.man_photo_show_other = ''
        return
      }
      this.idCardInfo.man_photo_show_other = ids[0];
    },
    async photoChangeIdOtherF(ids) {
      console.log(ids)
      if (ids.length <= 0) {
        this.idCardInfo.nation_photo_show_other = ''
        return
      }
      this.idCardInfo.nation_photo_show_other = ids[0];
    },
    async photoChangeBY(ids) {
      console.log(ids)
      if (ids.length <= 0) {
        this.educationData.by_certificate = ''
        return
      }
      this.educationData.by_certificate = ids[0];
    },
    async photoChangeXW(ids) {
      console.log(ids)
      if (ids.length <= 0) {
        this.educationData.xw_certificate = ''
        return
      }
      this.educationData.xw_certificate = ids[0];
    },
    async photoChangeSb(ids) {
      console.log("photoChangeSb",ids)
      if (ids.length <= 0) {
        this.employeeData.sb_card_photo = ''
        return
      }
      this.employeeData.sb_card_photo = ids[0];
    },
    async photoChangeHouse(ids) {
      if (ids.length <= 0) {
        this.employeeData.housing_fund_photo = ''
        return
      }
      this.employeeData.housing_fund_photo = ids[0];
    },
    async photoChangeBank(ids) {
      console.log("photoChangeBank", ids)
      if (ids.length <= 0) {
        this.employeeData.bank_card_photo = ''
        return
      }
      this.employeeData.bank_card_photo = ids[0];
      console.log("this.employeeData.bank_card_photo",this.employeeData.bank_card_photo)
    }
  },
  created() {
    this.getSexOption();
    this.getNationOption();
    this.getMarriageOption();
    this.getResidenceOption();
    this.getPoliticalOption();
    this.getContractCompanyOption();
    this.getContractPeriodTypeOption();
    this.getEmergencyOption();
    this.getDDTypeOption();
    this.getLaborOption();
    this.getReportManagerOption();
    this.getProbationTypeOption();
    // this.getEmployeeNo();
    this.getDepartmentList();
    this.getEmployeeType();
    this.getContractType();
    this.getPositionOption();
    this.getSalaryType();
    this.getSalaryBank();
    this.getSocialSecurity();
    this.getSocialSecurityBase();
    this.getSocialSecurityArea();
    this.getEmergencyRelation();
    this.getEducation();
    this.getHousingFundTmpl();
    this.getCardType();
    this.getFactory();
    this.getCompany();
    this.getLaborCompany();
    this.getSocialSecurityTmpl().then(() => {
      this.loadEmpInfo();
    });
  },
}
</script>

<style lang="less">
.employee-photo {
  .el-upload-list--picture-card {
    --el-upload-list-picture-card-size: 260px;
  }

  .el-upload--picture-card {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 230px;
    height: 270px;
  }
}


.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: var(--el-fill-color-light);
  color: var(--el-text-color-secondary);
  font-size: 30px;
}

.image-slot .el-icon {
  font-size: 30px;
}

.video-thumbnail {
  position: relative;
  display: inline-block;
}

.video-thumbnail::before {
  content: "";
  position: absolute;
  top: 5%;
  left: 30%;
  width: 320px; /* 根据需要调整方框的尺寸 */
  height: 400px; /* 根据需要调整方框的尺寸 */
  background-color: rgba(0, 0, 0, 0); /* 黑色半透明背景，根据需要调整 */
  border: 2px solid red; /* 白色边框，根据需要调整 */
  box-sizing: border-box; /* 边框计算在尺寸内 */
}

.switch-group {
  display: flex;
  flex-wrap: wrap;
  gap: 16px; /* 各开关之间的间距 */
  align-items: center;
}

.switch-item {
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.dept-label {
  font-size: 14px;
  color: #606266;
}
</style>